import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

/**
 * NextAssaltoModal - Modal per confermare il passaggio all'assalto successivo
 * 
 * Props:
 * - visible: boolean - se mostrare il modal
 * - onClose: () => void - callback per chiudere
 * - onConfirm: () => void - callback per confermare e passare al prossimo assalto
 * - currentAssalto: number - indice assalto corrente (0-based)
 * - scoreA: number - punteggio squadra A
 * - scoreB: number - punteggio squadra B
 */
const NextAssaltoModal = ({
    visible = false,
    onClose,
    onConfirm,
    currentAssalto = 0,
    scoreA = 0,
    scoreB = 0,
}) => {
    if (!visible) return null;

    return (
        <View style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20
        }}>
            <View style={{
                backgroundColor: '#fff',
                borderRadius: 12,
                padding: 24,
                width: '90%',
                maxWidth: 500
            }}>
                <Text style={{ fontSize: 24, fontWeight: 'bold', color: '#1976d2', marginBottom: 16, textAlign: 'center' }}>
                    Fine tempo assalto {currentAssalto + 1}
                </Text>
                <Text style={{ fontSize: 16, color: '#555', marginBottom: 24, textAlign: 'center' }}>
                    Il tempo dell'assalto è terminato. Procedere all'assalto successivo?
                </Text>

                <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginBottom: 24 }}>
                    <Text style={{ fontSize: 20, fontWeight: 'bold' }}>
                        Punteggio attuale: <Text style={{ color: '#d32f2f' }}>{scoreA} - {scoreB}</Text>
                    </Text>
                </View>

                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 }}>
                    <TouchableOpacity
                        onPress={onClose}
                        style={{
                            backgroundColor: '#f5f5f5',
                            paddingVertical: 12,
                            paddingHorizontal: 24,
                            borderRadius: 8,
                            flex: 1,
                            marginRight: 12
                        }}
                    >
                        <Text style={{ color: '#555', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>
                            Annulla
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                        onPress={onConfirm}
                        style={{
                            backgroundColor: '#2e7d32',
                            paddingVertical: 12,
                            paddingHorizontal: 24,
                            borderRadius: 8,
                            flex: 1,
                            marginLeft: 12
                        }}
                    >
                        <Text style={{ color: '#fff', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>
                            Prossimo Assalto
                        </Text>
                    </TouchableOpacity>
                </View>
            </View>
        </View>
    );
};

export default NextAssaltoModal;
